import axios from '@axios'

const route = 'audit/diary_execution'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page }) {
      return axios.get(route, { params: { items_per_page: itemsPerPage, page } })
    },
    store(context) {
      return axios.post(`${route}/store`)
    },
  },
}
